module.exports = __webpack_public_path__ + "static/followers-afda06d142e98f9c5ad8e34b7d949c8e.webp";